export const treasuryIdempotencyKey = (input, options = {}) => options.headers?.get?.('Idempotency-Key') || Object.entries(options.headers || {}).find(([key]) => key.toLowerCase() === 'idempotency-key')?.[1] || input?.requestId;
// Durable metadata must identify the same operation as the header and body.
export const treasuryRecoveryRequestOptions = (options, requestId) => {
  if (!options.headers) return options;
  const entries = typeof options.headers.entries === 'function' ? Array.from(options.headers.entries()) : Object.entries(options.headers);
  return {...options, headers: {...Object.fromEntries(entries.filter(([key]) => key.toLowerCase() !== 'idempotency-key')), 'Idempotency-Key': requestId}};
};
